import { LAYER_CRYSTAL } from "./constants";

export const markers = [
  // position is reversed with leaflet: [y, x]
  {
    position: [9922, 12834],
    icon: 1,
    layer: LAYER_CRYSTAL,
    text: "You found a documentation of a malachite",
    image: "Documentation of stones Malachite.jpg",
  },
  {
    position: [9687, 5029],
    icon: 2,
    layer: LAYER_CRYSTAL,
    text: "You found a moment when stars were falling",
    image: "falling star.jpg",
  },
  {
    position: [10637, 2383],
    icon: 3,
    layer: LAYER_CRYSTAL,
    text: "You found a sacred knowledge",
    image: "sacred knowledge.jpg",
  },
  {
    position: [8259, 7044],
    icon: 4,
    layer: LAYER_CRYSTAL,
    text: "You found a future prediction of obsidian dreams",
    image: "obsidian dream.jpg",
  },
  {
    position: [7051, 10349],
    icon: 5,
    layer: LAYER_CRYSTAL,
    text: "You found a mysterious cave... would you enter?",
    image: "cave.JPG",
  },
  {
    position: [6421, 3021],
    icon: 6,
    layer: LAYER_CRYSTAL,
    text: "You found a structure of reality",
    image: "Mapping volcano.jpg",
  },
  {
    position: [4869, 1958],
    icon: 7,
    layer: LAYER_CRYSTAL,
    text: "You found the beginning of things",
    image: "beginning.jpg",
  },
  {
    position: [5003, 4709],
    icon: 8,
    layer: LAYER_CRYSTAL,
    text: "You found an eye of baba yaga",
    image: "baba yaga.jpg",
  },
  {
    position: [4166, 12488],
    icon: 9,
    layer: LAYER_CRYSTAL,
    text: "You found a stone of your endless youth",
    image: "endless youth.jpg",
  },
  {
    position: [2362, 1726],
    icon: 10,
    layer: LAYER_CRYSTAL,
    text: "You found an entrance",
    image: "entrance.jpg",
  },
  {
    position: [2363, 8608],
    icon: 11,
    layer: LAYER_CRYSTAL,
    text: "You found a story of a volcano",
    image: "memory of volcano.jpg",
  },
  {
    position: [1695, 11262],
    icon: 12,
    layer: LAYER_CRYSTAL,
    text: "You found a ritual location",
    image: "ritual.JPG",
  },
];
